import React, { Component, Fragment } from "react";
import CreateNewSurvey from "../../pages/survey/CreateNew";
import _ from "lodash";

class SurveyCreationSteps extends Component {
	componentDidMount() {
		this.props.getByIdClient(this.props.currentClient.id);
	}
	/*
		on initalise state.surveyProgress du component SurveyCreationSteps qui devra contenir tous
		les éléments sélectionner durant les différents étapes
	 */
	state = {
		surveyProgress: {
			statusProgress: false,
			surveyId: null,
			label: "",
			stepCreation: 0,
			assortments: "",
			periodicity: {},
			model: [],
			locations: [],
			secteurs: [],
			locationTypes: [],
			surveyTitle: this.props.currentClient.label
		},
		modelClient: [],
	};
	// On récupère les assortiement pour afficher les modèle client.
	// Pour notre exemple
	componentWillReceiveProps(nextProps) {
		this.handleSetAssortement(nextProps.assortmentClient);
	}
	// On passe en argument l'assortiement
	handleSetAssortement = assortments => {
		let retailersModel = [];
		let surveyProgress = this.state.surveyProgress;
		let assortementList = assortments;

		/*
		on selectionne le modèle de chaque assortiement et leurs périodicité pour alimenter
		l'object modelClient.
		*/
		_.forEach(assortementList, (retailer, index) => {
			let retailerModel = { ...retailer.retailer };

			let assignPeriod = _.assign(retailerModel, {
				_id: retailer._id,
				assortmentLabel: retailer.assortmentLabel,
				retailer_id: retailer.retailer_id,
				retailer_label: retailer.retailer_label,
				periodicity: retailer.periodicity,
				products: retailer.allProducts,
				ranges: retailer.allRanges,
				categories: retailer.allCategories,
				locationsStructure: retailer.locationsStructure,
				client: retailer.client,
				retailer: retailer.retailer,
				locations:retailer.allLocationTypes
			});

			retailersModel.push(assignPeriod);
		});
		this.setState({ modelClient: retailersModel });
		this.props.addStepSurvey(surveyProgress);
	};

	render() {
		const { location, handleClick, isModify } = this.props;
		const { modelClient } = this.state;

		return (
			<Fragment>
				{/*
					On déclare le composant SurveyCreation qui est le point d'entrée
					du formulaire de création du survey
				*/}
				<CreateNewSurvey
					location={location}
					handleClick={handleClick}
					modelClient={modelClient}
					isModify={isModify}
				/>
			</Fragment>
		);
	}
}

SurveyCreationSteps.defaultProps = {
	//On decalre une variable qui definie si bous sommes sur une création ou une modification du questionnaire
	isModify: false,
};

export default SurveyCreationSteps;



// WEBPACK FOOTER //
// src/components/survey/SurveyCreationSteps.js